if (!String.prototype.includes) {
    String.prototype.includes = function(searchElement, fromIndex) {
        if ((fromIndex | 0) + searchElement.length > this.length) {
            return false;
        } else {
            return this.indexOf(searchElement, fromIndex) >= 0;
        }
    }
}
